import { FlexColProps, FlexRowProps } from './@types/FlexLayoutProps';
import { FlexRow } from './handles/FlexRow';
import { FlexRowProvider } from './hooks/useFlexRow';

import './FlexLayout.scss';
import { FlexColProvider } from './hooks/useFlexCol';
import { FlexCol } from './handles/FlexCol';
import FlexColChild from './handles/FlexColChild';
import { FlexLayoutContextProvider, useFlexLayoutContext } from './hooks/FlexLayoutContext';

function Row(props: FlexRowProps) {
	const context = useFlexLayoutContext();
	return (
		<FlexLayoutContextProvider parent={'ROW'}>
			<FlexRowProvider {...props} parent={context?.parent}>
				<FlexRow>{props.children}</FlexRow>
			</FlexRowProvider>
		</FlexLayoutContextProvider>
	);
}

function Col(props: FlexColProps) {
	const context = useFlexLayoutContext();
	return (
		<FlexLayoutContextProvider parent={'COL'}>
			<FlexColProvider {...props} parent={context?.parent}>
				<FlexCol>
					{props.children?.map((comp: any, index: any) => (
						<FlexColChild key={`flex-col-child-${index}`}>{comp}</FlexColChild>
					))}
				</FlexCol>
			</FlexColProvider>
		</FlexLayoutContextProvider>
	);
}

export const FlexLayout = {
	Row,
	Col,
};
